import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import { OptionHeading } from '../styles';

const { Option } = Select;

const styles = { width: '100%', maxWidth: 320 };

const ChoroplethOptions = ({
  aggregates,
  selectedAggregateId,
  onChangeAggregate,
}) => (
  <>
    <OptionHeading>Insight To Display</OptionHeading>
    <p>
      Choose which insight to shade across the selected boundaries. Choropleth maps compare
      aggregate values by area rather than individual point density.
    </p>
    <Select
      style={styles}
      placeholder="Choose an insight"
      value={selectedAggregateId || undefined}
      onChange={onChangeAggregate}
    >
      {aggregates.map(({ id, name }) => (
        <Option key={id} value={id}>{name}</Option>
      ))}
    </Select>
  </>
);

ChoroplethOptions.propTypes = {
  aggregates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  })).isRequired,
  selectedAggregateId: PropTypes.string,
  onChangeAggregate: PropTypes.func.isRequired,
};

export default React.memo(ChoroplethOptions);
